import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LoadingState } from '@/components/common/loading';
import styles from './CallbackPage.module.css';

/**
 * OAuth callback page - handles redirect from Gateway after authentication
 */
export function CallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      // Redirect to login with error
      navigate(`/login?error=${error}`);
      return;
    }

    // Success - redirect to home (WorkspaceRedirect handles routing)
    // The Gateway has already set the session cookie
    navigate('/');
  }, [error, navigate]);

  return (
    <div className={styles.container}>
      <LoadingState centered size="lg" text={t('auth.callback.processing')} />
    </div>
  );
}
